import { useState, useEffect } from "react";
import Header from "../component/layout/Header";
import Footer from "../component/layout/Footer";
import Menu from "../component/Menu/Menu.jsx";
import BackgroundWrapper from "../component/background-wrapper/bgwrapper.jsx";
import bg_second from "../assets/bg_app.png";
import api from "../utils/api.js";

const MenuPage = () => {
  const RestaurantSavedId =
    JSON.parse(localStorage.getItem("selectedRestaurantId")) || "";

  const [locationData, setLocationData] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      if (!RestaurantSavedId) return; // 🚀 avoid invalid call

      try {
        const response = await api.get(`/restaurant/${RestaurantSavedId}`);
        const results = response.data?.data || {};
        setLocationData(results);
        console.log("menuPage", results);
      } catch (error) {
        console.error("Error fetching restaurant data:", error);
      }
    };

    fetchData();
    window.scrollTo(0, 0);
  }, [RestaurantSavedId]);

  return (
    <div className="b">
      <BackgroundWrapper
        bgImage={locationData?.bgImage && locationData?.bgImage?.[0] || bg_second}
      >
        <Header activeLink={"menu"} />
        <Menu menuImage={locationData?.menuPageImage && locationData?.menuPageImage[0]}/>
        <Footer />
      </BackgroundWrapper>
    </div>
  );
};

export default MenuPage;
